export default "__VITE_ASSET__BvGh_UNd__"